import React, { useState } from "react";

const EVA_IMAGE = "/eva/images/eva_square.png";

export const DEFAULT_EVA_SETTINGS = {
    displayMode: "MODAL",
    interactionMode: "ASK",
    welcomeMessage:
        "Hello! I'm Eva, your workplace assistant. Would you like me to show you around?",
    instructions:
        "Help visitors understand the building and its facilities.",
    showAvatar: true,
    enableVoice: true,
    autoStart: false
};


export function CmsEvaPreview({ block, onLaunch })
{
    const settings = {
        ...DEFAULT_EVA_SETTINGS,
        ...(block.evaSettings || {})
    };

    const isModal = settings.displayMode === "MODAL";
    const isCard = settings.displayMode === "CARD";

    return (
        <div className={`cms-eva-preview ${isCard ? "cms-eva-preview-card" : ""}`}>

            <div className="cms-eva-preview-header">

                {settings.showAvatar && (
                    <img
                        src={EVA_IMAGE}
                        alt="Eva"
                        className="cms-eva-avatar"
                    />
                )}

                <div>
                    <div className="cms-eva-eyebrow">
                        OMNISCAN AI ASSISTANT
                    </div>

                    <h3>{block.title || "Ask Eva"}</h3>

                    <p>{settings.welcomeMessage}</p>
                </div>

            </div>

            <div className="cms-eva-preview-footer">

                {isModal || isCard ? (
                    <button
                        type="button"
                        className="cms-eva-launch"
                        onClick={onLaunch}
                    >
                        Open Eva ↗
                    </button>
                ) : (
                    <div className="cms-eva-input-preview">
                        <span>Ask Eva a question...</span>
                        {settings.enableVoice && <span>🎙</span>}
                    </div>
                )}

            </div>

        </div>
    );
}


export default function CmsEvaEditor({ block, onChange })
{
    const [showPreview, setShowPreview] = useState(false);

    const settings = {
        ...DEFAULT_EVA_SETTINGS,
        ...(block.evaSettings || {})
    };

    const update = (key, value) =>
    {
        onChange({
            evaSettings: {
                ...settings,
                [key]: value
            }
        });
    };

    return (
        <div className="cms-eva-editor">

            <div className="cms-eva-editor-heading">
                <img src={EVA_IMAGE} alt="Eva" />

                <div>
                    <h3>Eva Interaction</h3>
                    <p>
                        Configure how Eva appears and speaks
                        to your visitors.
                    </p>
                </div>
            </div>

            <label>
                Component title

                <input
                    value={block.title || ""}
                    onChange={e =>
                        onChange({ title: e.target.value })
                    }
                />
            </label>

            <label>
                What should Eva say first?

                <textarea
                    rows={4}
                    value={settings.welcomeMessage}
                    onChange={e =>
                        update("welcomeMessage", e.target.value)
                    }
                />
            </label>

            <label>
                Display style

                <select
                    value={settings.displayMode}
                    onChange={e =>
                        update("displayMode", e.target.value)
                    }
                >
                    <option value="INLINE">
                        Inline — embedded in page
                    </option>

                    <option value="CARD">
                        Card — compact Eva launcher
                    </option>

                    <option value="MODAL">
                        Large modal — full Eva experience
                    </option>
                </select>
            </label>

            <label>
                Interaction mode

                <select
                    value={settings.interactionMode}
                    onChange={e =>
                        update("interactionMode", e.target.value)
                    }
                >
                    <option value="SPEAK">
                        Speak — deliver a message
                    </option>

                    <option value="ASK">
                        Ask — interactive conversation
                    </option>

                    <option value="COLLECT">
                        Collect — guided questions (future)
                    </option>
                </select>
            </label>

            <div className="cms-eva-options">

                <label>
                    <input
                        type="checkbox"
                        checked={settings.showAvatar}
                        onChange={e =>
                            update("showAvatar", e.target.checked)
                        }
                    />
                    Show Eva avatar
                </label>

                <label>
                    <input
                        type="checkbox"
                        checked={settings.enableVoice}
                        onChange={e =>
                            update("enableVoice", e.target.checked)
                        }
                    />
                    Enable voice interaction
                </label>

                <label>
                    <input
                        type="checkbox"
                        checked={settings.autoStart}
                        onChange={e =>
                            update("autoStart", e.target.checked)
                        }
                    />
                    Start automatically when opened
                </label>

            </div>

            <label>
                Instructions / context for Eva

                <textarea
                    rows={3}
                    value={settings.instructions}
                    onChange={e =>
                        update("instructions", e.target.value)
                    }
                />
            </label>

            <div className="cms-eva-editor-actions">
                <button
                    type="button"
                    onClick={() => setShowPreview(true)}
                >
                    Preview Eva
                </button>
            </div>

            {showPreview && (
                <div
                    className="cms-eva-demo-backdrop"
                    onClick={() => setShowPreview(false)}
                >
                    <div
                        className={
                            settings.displayMode === "MODAL"
                                ? "cms-eva-demo-modal"
                                : "cms-eva-demo-inline"
                        }
                        onClick={e => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className="cms-eva-demo-close"
                            onClick={() => setShowPreview(false)}
                        >
                            ×
                        </button>

                        <CmsEvaPreview block={block} />

                        <div className="cms-eva-demo-message">
                            {settings.interactionMode === "SPEAK"
                                ? "Eva would deliver the configured message."
                                : settings.interactionMode === "COLLECT"
                                    ? "Guided question collection will be available later."
                                    : "Eva's conversation would begin here."}
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}